import { PageHero } from "../components/PageHero";
import { InquiryForm } from "../components/InquiryForm";
import { Star } from "../components/brand/Logo";
import { useLang } from "../i18n/LangContext";
import { SOCIALS } from "../i18n/strings";

export default function Contact() {
  const { t } = useLang();
  return (
    <>
      <PageHero testid="contact-hero" label={t.contact.label} lines={t.contact.title} accentLine={2} sub={t.contact.sub} />
      <section className="mx-auto grid max-w-[1440px] gap-16 px-5 pb-32 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <div className="rounded-sm border border-white/10 bg-char/60 p-6 md:p-12"><InquiryForm /></div>
        </div>
        <aside className="space-y-12 lg:col-span-4">
          <div>
            <p className="label text-mist">{t.contact.social}</p>
            <ul className="mt-5 space-y-3">
              {SOCIALS.map((s) => (
                <li key={s.key}>
                  <a href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`contact-social-${s.key}`}
                    className="flex items-center justify-between border-b border-white/10 pb-3 font-display text-xl text-ivory hover:text-lav">
                    {s.label}<Star className="h-4 w-4 text-lav" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <p className="text-sm leading-relaxed text-mist">{t.common.remote}</p>
        </aside>
      </section>
    </>
  );
}
